import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronRightSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.0141 4.6001L6.6001 6.0141L10.6001 10.0131L6.6001 14.0141L8.0141 15.4281L12.0151 11.4281L13.4281 10.0131L12.0151 8.6001L8.0141 4.6001Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgChevronRightSmall);
export { ForwardRef as ReactComponent };
